// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"281":"10583ade","453":"01c3e9fd","581":"2bfe0b7f"}[chunkId] + ".chunk.js";
};